export const initDropdowns = () => {
    // Find all components with the base class
    const dropdowns = document.querySelectorAll('.c-dropdown');

    dropdowns.forEach(dropdown => {
        const header = dropdown.querySelector('.c-dropdown__header');
        const list = dropdown.querySelector('.c-dropdown__list');
        const items = dropdown.querySelectorAll('.c-dropdown__item');
        const currentText = dropdown.querySelector('.c-dropdown__current');

        header.addEventListener('click', (e) => {
            e.stopPropagation();
            // Close other open dropdowns first
            document.querySelectorAll('.c-dropdown__list.is-open').forEach(l => {
                if (l !== list) l.classList.remove('is-open');
            });
            list.classList.toggle('is-open');
        });

        items.forEach(item => {
            item.addEventListener('click', () => {
                if (currentText) currentText.textContent = item.textContent;
                list.classList.remove('is-open');
                
                // Dispatch a custom event in case the system needs to react
                dropdown.dispatchEvent(new CustomEvent('change', { 
                    detail: { value: item.dataset.value } 
                }));
            });
        });
    });

    // Close all dropdowns when clicking outside
    document.addEventListener('click', () => {
        document.querySelectorAll('.c-dropdown__list').forEach(l => l.classList.remove('is-open'));
    });
};